module.exports = __webpack_public_path__ + "img/h5_logo.7c203222.png";